import { draftSchema, type Draft } from "../shared/domain";
const prefix = (email: string) => `ailink:draft:${email}`;
export function recoveries(email: string): Draft[] {
  const found: { draft: Draft; updatedAt: string }[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)!;
    if (key !== prefix(email) && !key.startsWith(prefix(email) + ":")) continue;
    try {
      const value = JSON.parse(localStorage.getItem(key) || "null");
      found.push({
        draft: draftSchema.parse(value.draft),
        updatedAt: value.updatedAt || "",
      });
    } catch {}
  }
  return found
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .map((r) => r.draft)
    .filter((d, i, all) => all.findIndex((x) => x.id === d.id) === i);
}
export function saveRecovery(email: string, draft: Draft) {
  // Each document has its own slot: starting another draft must not overwrite an unsaved one.
  localStorage.setItem(
    `${prefix(email)}:${draft.id}`,
    JSON.stringify({
      schemaVersion: 1,
      draft,
      updatedAt: new Date().toISOString(),
    }),
  );
  try {
    const old = JSON.parse(localStorage.getItem(prefix(email)) || "null");
    if (old?.draft.id === draft.id) localStorage.removeItem(prefix(email));
  } catch {}
}
export function removeRecovery(email: string, id: string) {
  try {
    localStorage.removeItem(`${prefix(email)}:${id}`);
    const old = JSON.parse(localStorage.getItem(prefix(email)) || "null");
    if (old?.draft.id === id) localStorage.removeItem(prefix(email));
  } catch {}
}
export function clearRecoveries(email: string) {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, i) =>
      localStorage.key(i),
    );
    for (const key of keys) {
      if (
        key &&
        (key === prefix(email) || key.startsWith(prefix(email) + ":"))
      ) {
        localStorage.removeItem(key);
      }
    }
  } catch {}
}
